import { apiRequest, API_ENDPOINTS } from '../config/api';

export interface BcmComputed {
  children_count: number;
  has_linked_systems: boolean;
}

export interface BcmNodeEntry {
  id: string;
  name: string;
  status?: string;
  parent_id?: string;
  attributes?: Record<string, unknown>;
  _computed: BcmComputed;
}

export interface BcmNode {
  id: string;
  map_entry_id: string;
  bc_entry_id: string;
  x: number;
  y: number;
  w: number;
  h: number;
  created_at: string;
  updated_at: string;
  entry?: BcmNodeEntry;
}

export interface AddBcmNodeRequest {
  bc_entry_id: string;
  parent_bc_entry_id?: string | null;
  x: number;
  y: number;
  w?: number;
  h?: number;
}

export interface UpdateBcmNodePositionRequest {
  x: number;
  y: number;
  w: number;
  h: number;
}

export interface SyncBcmMapResponse {
  removed_ghost_count: number;
}

export const bcmApi = {
  listNodes: async (projectId: string, mapEntryId: string): Promise<BcmNode[]> =>
    (await apiRequest(API_ENDPOINTS.bcm.nodes(projectId, mapEntryId), { method: 'GET' })) ?? [],

  addNode: (projectId: string, mapEntryId: string, body: AddBcmNodeRequest): Promise<BcmNode> =>
    apiRequest(API_ENDPOINTS.bcm.nodes(projectId, mapEntryId), {
      method: 'POST',
      body: JSON.stringify(body),
    }),

  updateNodePosition: (
    projectId: string,
    mapEntryId: string,
    nodeId: string,
    body: UpdateBcmNodePositionRequest,
  ): Promise<BcmNode> =>
    apiRequest(API_ENDPOINTS.bcm.node(projectId, mapEntryId, nodeId), {
      method: 'PUT',
      body: JSON.stringify(body),
    }),

  deleteNode: (projectId: string, mapEntryId: string, nodeId: string): Promise<void> =>
    apiRequest(API_ENDPOINTS.bcm.node(projectId, mapEntryId, nodeId), { method: 'DELETE' }),

  syncMap: (projectId: string, mapEntryId: string): Promise<SyncBcmMapResponse> =>
    apiRequest(API_ENDPOINTS.bcm.sync(projectId, mapEntryId), { method: 'POST' }),
};

export async function getDefaultBcmMap(projectId: string): Promise<any> {
  return apiRequest(API_ENDPOINTS.bcm.defaultMap(projectId));
}
